export default __webpack_public_path__ + "static/media/endIcon.e59e5a3c.svg";